export const DEFAULT_CURRENCY_SYMBOL = "";

const parseMaybeJson = (value) => {
    if (typeof value !== "string") return value;

    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
};

export const getCurrencySymbol = (item, fallback = DEFAULT_CURRENCY_SYMBOL) => {
    const productDetails = parseMaybeJson(item?.product_details || item?.productDetails);

    return (
        item?.currency_symbol ||
        item?.currencySymbol ||
        item?.currency?.symbol ||
        item?.product?.currency_symbol ||
        item?.product?.currencySymbol ||
        item?.product?.currency?.symbol ||
        productDetails?.currency_symbol ||
        productDetails?.currencySymbol ||
        productDetails?.currency?.symbol ||
        item?.productFullInfo?.currency_symbol ||
        item?.product_full_info?.currency_symbol ||
        fallback
    );
};

export const formatCurrencyAmount = (amount, item, fallback = DEFAULT_CURRENCY_SYMBOL) => {
    return `${getCurrencySymbol(item, fallback)}${amount}`;
};
